import { AddBox, Delete, Sort } from "@mui/icons-material";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, InputLabel, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";

const Gallery = () => {
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);
    const [sort, setSort] = useState("");
    const [isLargeViewOpen, setIsLargeViewOpen] = useState(false);
    const [selectedURL, setSelectedURL] = useState({});
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [file, setFile] = useState({});
    const getGalleryRef = useRef();

    const [images, setImages] = useState([{
        title: '',
        image_url: '',
        minutes: '',
        createdAt: ''
    }])

    const [image, setImage] = useState({
        gallery_id: '',
        title: '',
        image_url: '',
        minutes: ''
    })

    const handleImage = (event) => {
        const file = event.target.files[0];
        setFile(file)
    };

    const handleSorting = (value) => {
        setSort(value);
        let sortedImages = [...images];

        switch (value) {
            case "1":
                sortedImages.sort((a, b) => parseInt(b.minutes) - parseInt(a.minutes));
                break;
            case "2":
                sortedImages.sort((a, b) => parseInt(a.minutes) - parseInt(b.minutes));
                break;
            case "3":
                sortedImages.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                break;
            case "4":
                sortedImages.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                break;
            case "0":
            default:
                break;
        }

        setImages(sortedImages);
    };

    const handleImageUpload = async () => {
        setOpen(true);

        const formData = new FormData();

        formData.append('title', image.title)
        formData.append('minutes', image.minutes)
        formData.append('image_url', file)

        await axiosInstance.post(`gallery/add`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(() => {
            setMessage(`Success, successfully added ${image.title}`)
            setTimeout(() => {
                setOpen(false);
                if(getGalleryRef.current) getGalleryRef.current()
                setIsAddModalOpen(false)
            }, 2000)
        }).catch((error) => {
            if(error.response && error.response.data.error) {
                setMessage(`Failure, ${error.response.data.error}`)
            } else {
                setMessage(`Failure, ${error}`)
            }
            setTimeout(() => { setOpen(false)}, 2000);
        })
    }

    const handleLargeView = (url) => {
        setIsLargeViewOpen(true);
        setSelectedURL(url)
    }

    const handleDelete = async () => {
        setOpen(true);

        await axiosInstance.delete(`gallery/delete/${selectedURL.gallery_id}`).then((response) => {
            setMessage(`Success, successfully deleted ${selectedURL.title}`)
            setTimeout(() => {
                setOpen(false);
                if(getGalleryRef.current) getGalleryRef.current()
                setIsLargeViewOpen(false)
            }, 2000)
        }).catch((error) => {
            setMessage(`Failed to delete ${selectedURL.title}` );
            setTimeout(() => { setOpen(false)}, 2000);
        })
    }

    useEffect(() => {
        const getGallery = async () => {
            await axiosInstance.get(`gallery/all`).then((response) => {
                setImages(response.data.data);
            }).catch((error) => {
                if(error.response && error.response.data.message === "No images found in the gallery") {
                    setImages([]);
                } else if(error.response && error.response.data.message !== "No images found in the gallery") {
                    setImages([]);
                } else {
                    setImages([]);
                }
            });
        }

        getGalleryRef.current = getGallery;

        getGallery()
    }, [])

    return(
        <div>
            <div className="md:flex justify-between md:flex-wrap">
                <Typography variant='h4' className="text-blue-800">Gallery</Typography>
                <div className="mt-4 md:mt-0"><Button className="flex gap-3" variant="outlined" onClick={() => setIsAddModalOpen(true)}><AddBox /> Add Photo</Button></div>
            </div>

            <div className="bg-white p-4 rounded-md my-4">
                <FormControl className="w-48" style={{ marginBottom: 15 }}>
                    <InputLabel>Sort <Sort /></InputLabel>
                    <Select label="Select size" value={sort} onChange={(e) => handleSorting(e.target.value)}>
                        <MenuItem value="0">
                            Select size
                        </MenuItem>
                        <MenuItem value="1">
                            Highest points
                        </MenuItem>
                        <MenuItem value="2">
                            Lowest points
                        </MenuItem>
                        <MenuItem value="3">
                            Current Images
                        </MenuItem>
                        <MenuItem value="4">
                            Oldest images
                        </MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div className="w-full">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                    {images.length > 0 ? 
                        images.map((image, index) =>
                            <article key={index} onClick={() => handleLargeView(image)} className="cursor-pointer" title={`Title: ${image.title}. Points: ${image.minutes}`} style={{ border: '1px solid #d6d6d6' }}>
                                <img src={image.image_url} alt={image.title} />
                                <span className="pl-2">Points {image.minutes}</span>
                            </article>
                        )
                    :
                        <div className="w-full text-red-500 font-bold text-center text-xl">Images not found</div>
                    }
                </div>
            </div>

            {/* Add Member Modal */}
            <Dialog open={isAddModalOpen} onClose={() => setIsAddModalOpen(false)}>
                <DialogTitle className="text-blue-950">Add Photo</DialogTitle>
                <DialogContent>
                    <FormLabel>Select photo</FormLabel>
                    <TextField variant="outlined" onChange={(e) => handleImage(e)} fullWidth type="file" />
                    <div className="mt-4"></div>
                    <TextField variant="outlined" value={image.title} onChange={(e) => setImage((prev) => ({ ...prev, title: e.target.value  }))} fullWidth type="text" label="Image title to be used in searching" />
                    <div className="mt-4"></div>
                    <TextField variant="outlined" value={image.minutes} onChange={(e) => setImage((prev) => ({ ...prev, minutes: e.target.value  }))} fullWidth type="text" label="Image points(optional) to be used in searching" />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsAddModalOpen(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button color="primary" onClick={handleImageUpload}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {/* View large image Modal */}
            <Dialog open={isLargeViewOpen} onClose={() => setIsLargeViewOpen(false)}>
                <DialogTitle className="text-blue-950">View larger Photo for {selectedURL.title}</DialogTitle>
                <DialogContent>
                    <article>
                        <img src={selectedURL.image_url} alt={selectedURL.title} />
                    </article>
                </DialogContent>
                <DialogActions>
                    <Typography>Points: {selectedURL.minutes || 0}</Typography>
                    {/* <Button color="success" title="Download"
                        onClick={() => {
                            const link = document.createElement('a');
                            link.href = selectedURL.image_url;
                            link.download = `${selectedURL.title || 'downloaded-image'}.jpg`;
                            link.rel = 'noopener noreferrer';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }}
                    >
                        <Download />
                    </Button> */}
                    <Button color="error" title="Delete" onClick={handleDelete}>
                        <Delete />
                    </Button>
                    <Button onClick={() => setIsLargeViewOpen(false)} color="secondary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={open} autoHideDuration={10000} onClose={() => setOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert color={message.startsWith("Success") ? 'success' : message.startsWith('Failure') ? 'error' : message.startsWith('Warning') ? 'warning' : 'info'}>{message}</Alert>
            </Snackbar>
        </div>
    )
}

export default Gallery